
import React, { Component } from 'react';
import { Modal, Button, Row, Divider, Col, Select, DatePicker } from 'antd';

import './memberDetailStyle.css';

import PageTable from '../../ui/PageTable';
//引入消息提示相关组件
import messager from '../../ui/messager';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';

class MemberDetail extends Component {

    operateTypeMap = {
        1: "充值", 2: "退款", 3: "开票", 4: "补价", 5: "返款", 6: "冲正",
        7: "扣款", 8: "维保查询", 9: "冻结保证金", 10: "解冻保证金", 11: "没收保证金", 12: "过户代办",
        13: "检测", 14: "新车上牌", 15: "其他业务", 16: "停车券",17: "赠送"
    };

    accountColumns = [{
        title: '操作类型',
        dataIndex: 'operateType',
        width: '10%',
        format: this.operateTypeMap
    }, {
        title: '金额',
        dataIndex: 'amount',
        width: '10%',
    }, {
        title: '实际金额',
        dataIndex: 'actualAmount',
        width: '10%',
    }, {
        title: '赠送金额',
        dataIndex: 'giftAmount',
        width: '10%',
    }, {
        title: '操作人',
        dataIndex: 'operator',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: '20%',
    }];

    bondColumns = [{
        title: '业务类型',
        dataIndex: 'business',
        width: '10%',
        format: { "agent": "代办", "mall": "商城", "auction": "竞价", "tenant": "市场" }
    }, {
        title: '操作类型',
        dataIndex: 'operateType',
        width: '10%',
        format: this.operateTypeMap
    }, {
        title: '金额',
        dataIndex: 'amount',
        width: '10%',
    }, {
        title: '可用金额',
        dataIndex: 'bondFree',
        width: '10%',
    }, {
        title: '冻结金额',
        dataIndex: 'bondFreeze',
        width: '10%',
    }, {
        title: '操作人',
        dataIndex: 'operator',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: '20%',
    }];



    propertyColumns = [{
        title: '操作类型',
        dataIndex: 'operateType',
        width: '10%',
        format: this.operateTypeMap
    }, {
        title: '金额',
        dataIndex: 'amount',
        width: '10%',
    }, {
        title: '操作人',
        dataIndex: 'operator',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: '20%',
    }];

    durationColumns = [{
        title: '操作类型',
        dataIndex: 'operateType',
        width: '10%',
        format: this.operateTypeMap
    }
    , {
        title: '关联流水',
        dataIndex: 'serialNo',
        width: '10%',
    }
    , {
        title: '时长',
        dataIndex: 'duration',
        width: '10%',
    }
    , {
        title: '操作人',
        dataIndex: 'operator',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: '20%',
    }];


    state = {
        loadingVisible: false,

        //账户表格的查询
        account: {
            queryData: {
                operateType: ''
            },
            dates: [null, null],
        },
        //保证金表格的查询
        bond: {
            queryData: {
                operateType: '',
                business: "",
            },
            dates: [null, null],
        },
        duration: {
            queryData: {
                operateType: '',
            },
            dates: [null, null],
        },
        property: {
            queryData: {
                operateType: '',
            },
            dates: [null, null],
        }
    }

    /** 初始化表格信息 */
    loadTableData = (memberCode, business) => {
        let obj = this.state[business];
        let queryData = obj.queryData;
        queryData.memberCode = memberCode;
        this.setState({ [business]: obj });
        if (this[business] && this[business].loadData) {
            this[business].loadData(queryData);
        }
    }

    rangePickerChange = (business, dates, dateStrings) => {
        let obj = this.state[business];
        let queryData = obj.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        obj.dates = dates;
        this.setState({ [business]: obj });
        this[business].loadData(queryData);
    }

    selectChange = (business, field, value) => {
        let obj = this.state[business];
        let queryData = obj.queryData;
        queryData[field] = value;
        this.setState({ [business]: obj });
        this[business].loadData(queryData);
    }

    closeDialog = () => {
        const { onCancel } = this.props;
        this.setState({
            //账户表格的查询
            account: {
                queryData: {
                    operateType: ''
                },
                dates: [null, null],
            },
            //保证金表格的查询
            bond: {
                queryData: {
                    operateType: ''
                },
                dates: [null, null],
            }
        });
        onCancel();
    }

    //账户明细导出
    downloadCount = (business) => {
        let obj = this.state[business];
        let queryData = obj.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请先选择导出时间再进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        let fileName = this.props.editData.name + " " + queryData.startDate + "~" + queryData.endDate + " 账户记录.xlsx";
        http.download({
            url: '/' + this.props.content + "/downloadAccountRecord",
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        const { visible, editData, summary } = this.props;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="商户详细信息"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={this.closeDialog}
                footer={[
                    <Button key="take" type="primary" onClick={this.closeDialog}>确定</Button>,
                ]}
            >
                <Row>
                    <Divider orientation="left">基本信息</Divider>
                    <table className="detail-table detail-base-table">
                        <tbody>
                            <tr>
                                <td>会员编码：</td>
                                <td>{editData.code}</td>
                                <td>会员名称：</td>
                                <td>{editData.name}</td>
                                <td>证件号码：</td>
                                <td>{editData.creditNo}</td>
                            </tr>
                            <tr>
                                <td>联系人：</td>
                                <td>{editData.contactMan}</td>
                                <td>联系电话：</td>
                                <td>{editData.contactNumber}</td>
                                <td>地址：</td>
                                <td>{editData.address}</td>
                            </tr>
                            <tr>
                                <td>当前过户余额：</td>
                                <td>{editData.account}</td>
                                <td>过户实际余额：</td>
                                <td>{editData.actualAccount}</td>
                                <td>过户赠送余额：</td>
                                <td>{editData.giftAccount}</td>
                            </tr>
                            <tr>
                                <td>竞价保证金：</td>
                                <td>{editData.auctionBond}</td>
                                <td>竞价可用保证金：</td>
                                <td>{editData.auctionBondFree}</td>
                                <td>竞价冻结保证金：</td>
                                <td>{editData.auctionBondFreeze}</td>
                            </tr>
                            <tr>
                                <td>物管费余额：</td>
                                <td>{editData.propertyAccount}</td>
                                <td>停车时长：</td>
                                <td>{editData.durationAccount}</td>
                            </tr>
                        </tbody>
                    </table>
                    <Divider orientation="left">账户变动汇总</Divider>
                    <table className="detail-table detail-summary-table">
                        <tbody>
                            <tr>
                                <td>充值次数：</td>
                                <td>{summary.rechargeTimes}</td>
                                <td>累计充值金额：</td>
                                <td>{summary.rechargeAmount}</td>
                                <td>实际充值金额：</td>
                                <td>{summary.rechargeActualAmount}</td>
                                <td>累计赠送金额：</td>
                                <td>{summary.rechargeGiftAmount}</td>
                            </tr>
                            <tr>
                                <td>退款次数：</td>
                                <td>{summary.refundTimes}</td>
                                <td>累计退款金额：</td>
                                <td>{summary.refundAmount}</td>
                                <td>实际退款金额：</td>
                                <td>{summary.refundActualAmount}</td>
                                <td>回收赠送金额：</td>
                                <td>{summary.refundGiftAmount}</td>
                            </tr>
                            <tr>
                                <td>消费次数：</td>
                                <td>{summary.consumeTimes}</td>
                                <td>累计消费金额：</td>
                                <td>{summary.consumeAmount}</td>
                                <td>实际消费金额：</td>
                                <td>{summary.consumeActualAmount}</td>
                                <td>消费赠送金额：</td>
                                <td>{summary.consumeGiftAmount}</td>
                            </tr>
                        </tbody>
                    </table>
                    <Divider orientation="left">账户变动明细</Divider>
                    <div>
                        <Row style={{ paddingBottom: '10px' }}>
                            <Col span={24}>
                                <Select style={{ width: 120, marginLeft: '20px', marginRight: '20px' }}
                                    onChange={this.selectChange.bind(this, "account", "operateType")} value={this.state.account.queryData.operateType}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">充值</Select.Option>
                                    <Select.Option value="2">退款</Select.Option>
                                    <Select.Option value="3">开票</Select.Option>
                                    <Select.Option value="4">补价</Select.Option>
                                    <Select.Option value="5">返款</Select.Option>
                                    <Select.Option value="6">冲正</Select.Option>
                                    <Select.Option value="7">扣款</Select.Option>
                                    <Select.Option value="8">维保查询</Select.Option>
                                    <Select.Option value="12">过户代办</Select.Option>
                                    <Select.Option value="13">检测</Select.Option>
                                    <Select.Option value="14">新车上牌</Select.Option>
                                    <Select.Option value="15">其他业务</Select.Option>
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange.bind(this, "account")} value={this.state.account.dates} />

                                <Button type="primary" onClick={this.downloadCount.bind(this, "account")} style={{ float: "right" }}>导出</Button>
                            </Col>
                        </Row>
                        <PageTable
                            rowKey="id"
                            url={'/' + this.props.content + "/findAccountRecordPage"}
                            columns={this.accountColumns}
                            height={400}
                            pageSize={5}
                            loadData={(func) => { this.account = { loadData: func } }}
                            initParams={{ memberCode: editData.code }}
                        >
                        </PageTable>
                    </div>
                    <Divider orientation="left">保证金变动明细</Divider>
                    <div>
                        <Row style={{ paddingBottom: '10px' }}>
                            <Col span={24}>
                                <Select style={{ width: 120, marginLeft: '20px', marginRight: '20px' }}
                                    onChange={this.selectChange.bind(this, "bond", "business")} value={this.state.bond.queryData.business}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="auction">竞价</Select.Option>
                                    <Select.Option value="tenant">物业</Select.Option>
                                </Select>
                                <Select style={{ width: 120, marginLeft: '20px', marginRight: '20px' }}
                                    onChange={this.selectChange.bind(this, "bond", "operateType")} value={this.state.bond.queryData.operateType}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">充值</Select.Option>
                                    <Select.Option value="2">退款</Select.Option>
                                    <Select.Option value="7">扣款</Select.Option>
                                    <Select.Option value="9">冻结</Select.Option>
                                    <Select.Option value="10">解冻</Select.Option>
                                    <Select.Option value="11">没收</Select.Option>
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange.bind(this, "bond")} value={this.state.bond.dates} />
                            </Col>
                        </Row>
                        <PageTable
                            rowKey="id"
                            url={'/' + this.props.content + "/findBondRecordPage"}
                            columns={this.bondColumns}
                            height={400}
                            pageSize={5}
                            loadData={(func) => { this.bond = { loadData: func } }}
                            initParams={{ memberCode: editData.code }}
                        >
                        </PageTable>
                    </div>

                    <Divider orientation="left">停车时长变动明细</Divider>
                    <div>
                        <Row style={{ paddingBottom: '10px' }}>
                            <Col span={24}>
                                <Select style={{ width: 120, marginLeft: '20px', marginRight: '20px' }}
                                    onChange={this.selectChange.bind(this, "duration", "operateType")} value={this.state.duration.queryData.operateType}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">充值</Select.Option>
                                    <Select.Option value="2">退款</Select.Option>
                                    <Select.Option value="7">扣款</Select.Option>
                                    <Select.Option value="16">停车券</Select.Option>
                                    <Select.Option value="17">赠送</Select.Option>
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange.bind(this, "duration")} value={this.state.duration.dates} />
                            </Col>
                        </Row>
                        <PageTable
                            rowKey="id"
                            url={'/' + this.props.content + "/findDurationRecordPage"}
                            columns={this.durationColumns}
                            height={400}
                            pageSize={5}
                            loadData={(func) => { this.duration = { loadData: func } }}
                            initParams={{ memberCode: editData.code }}
                        >
                        </PageTable>
                    </div>

                    <Divider orientation="left">物管费变动明细</Divider>
                    <div>
                        <Row style={{ paddingBottom: '10px' }}>
                            <Col span={24}>
                                <Select style={{ width: 120, marginLeft: '20px', marginRight: '20px' }}
                                    onChange={this.selectChange.bind(this, "bond", "operateType")} value={this.state.bond.queryData.operateType}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">充值</Select.Option>
                                    <Select.Option value="2">退款</Select.Option>
                                    <Select.Option value="7">扣款</Select.Option>
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange.bind(this, "bond")} value={this.state.bond.dates} />
                            </Col>
                        </Row>
                        <PageTable
                            rowKey="id"
                            url={'/' + this.props.content + "/findPropertyRecordPage"}
                            columns={this.propertyColumns}
                            height={400}
                            pageSize={5}
                            loadData={(func) => { this.bond = { loadData: func } }}
                            initParams={{ memberCode: editData.code }}
                        >
                        </PageTable>
                    </div>
                </Row>
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </Modal >
        );
    }
}


export default MemberDetail;